// wrapper for google heat map control

var VeritracksHeatMapWrapper = function (aId, aMapId, aOptions) {

    var mThis = this,
        mDataSource = null,
        mMapOptions = {},
        mHeight = '100px',
        mCardTemplateName = '',
        mIsInitialized = false,
        mInitializedCallBack = null,
        mMap = null;

    if (aOptions) {
        if (aOptions.mapOptions) {
            mMapOptions = aOptions.mapOptions;
        }

        if (aOptions.height) {
            mHeight = aOptions.height;
        }

        if (aOptions.cardTemplateName) {
            mCardTemplateName = aOptions.cardTemplateName;
        }

        if (aOptions.initializeCallback) {
            mInitializedCallBack = aOptions.initializeCallback;
        }
    }//

    $("#" + aId).css("height", mHeight);
    loadTemplateHtml();
   

    function loadTemplateSuccess(responseText, textStatus, XMLHttpRequest) {        
        mIsInitialized = true;
        $("#" + aId).html(veritracks.system.encodeHtml(responseText));
        var encodedTextHtml = $("#" + aId).text();
        $("#" + aId).html(encodedTextHtml);
        veritracks.localization.localize('#' + mThis.ParentId);
        mMap = new sumo.maps.GoogleMapControl('uHeatMapPanel', aMapId, mMapOptions);
        mMap.render();
        initialize();
    }

    function initialize() {
        if (mInitializedCallBack != null) {
            mInitializedCallBack();
        }
    }

    function loadTemplateHtml() {
        $.get(mCardTemplateName, loadTemplateSuccess);
    }

    this.getMap = function () {
        return mMap;
    };


    
};